export const TRAINING_DATA_UPDATED_EVENT = 'td:training-updated';
export const TRAINING_DATA_UPDATED_KEY = 'td_training_updated_at';
export const MATCH_DATA_UPDATED_EVENT = 'td:match-updated';
export const MATCH_DATA_UPDATED_KEY = 'td_match_updated_at';
export const GOAL_DATA_UPDATED_EVENT = 'td:goal-updated';
export const GOAL_DATA_UPDATED_KEY = 'td_goal_updated_at';
export const SCHEDULE_DATA_UPDATED_EVENT = 'td:schedule-updated';
export const SCHEDULE_DATA_UPDATED_KEY = 'td_schedule_updated_at';

const safeStorage = () => {
  if (typeof window === 'undefined') return null;
  return window.localStorage || null;
};

export const getTrainingDataUpdatedAt = () => {
  try {
    return safeStorage()?.getItem(TRAINING_DATA_UPDATED_KEY) || '';
  } catch {
    return '';
  }
};

export const getMatchDataUpdatedAt = () => {
  try {
    return safeStorage()?.getItem(MATCH_DATA_UPDATED_KEY) || '';
  } catch {
    return '';
  }
};

export const getGoalDataUpdatedAt = () => {
  try {
    return safeStorage()?.getItem(GOAL_DATA_UPDATED_KEY) || '';
  } catch {
    return '';
  }
};

export const getScheduleDataUpdatedAt = () => {
  try {
    return safeStorage()?.getItem(SCHEDULE_DATA_UPDATED_KEY) || '';
  } catch {
    return '';
  }
};

const markDataUpdated = (storageKey, eventName) => {
  if (typeof window === 'undefined') return '';

  const timestamp = new Date().toISOString();

  try {
    safeStorage()?.setItem(storageKey, timestamp);
  } catch {
    /* Storage can be unavailable in private/browser-restricted contexts. */
  }

  // Same-tab route transitions do not fire the browser "storage" event, so
  // this custom event gives already-mounted athlete data views an immediate signal.
  window.dispatchEvent(
    new CustomEvent(eventName, { detail: { timestamp } })
  );

  return timestamp;
};

export const markTrainingDataUpdated = () =>
  markDataUpdated(TRAINING_DATA_UPDATED_KEY, TRAINING_DATA_UPDATED_EVENT);

export const markMatchDataUpdated = () =>
  markDataUpdated(MATCH_DATA_UPDATED_KEY, MATCH_DATA_UPDATED_EVENT);

export const markGoalDataUpdated = () =>
  markDataUpdated(GOAL_DATA_UPDATED_KEY, GOAL_DATA_UPDATED_EVENT);

export const markScheduleDataUpdated = () =>
  markDataUpdated(SCHEDULE_DATA_UPDATED_KEY, SCHEDULE_DATA_UPDATED_EVENT);
